var Base = require('./_BaseView'),
    scope = require('scope'),
    bootstrap = require('bootstrap/dist/js/bootstrap.bundle'),
    scroll = require('../helpers/json'),
    View = Base.extend({
        template: require('templates/pages/contactSuccess.hbs'),
        name: 'contactsuccess',
        behaviors: {
        },
        ui: {
        },
        events: {
            'click .planosindicados__back': 'backHome',
        },
        partials: {},
        onAttach: function () {
        },
        backHome: function (e) {
            e.preventDefault();
            scope.app.anchor(0);
            var View = require('views/Home');
            scope.app.go(new View({}));
        },
        onDomRefresh: function () {
        },
    });
module.exports = View;



// WEBPACK FOOTER //
// ./resources/scripts/views/ContactSuccess.js